import React, { useState } from 'react';

const PALETTE = ['#E8502A', '#2D7A4A', '#B8860B', '#1A1A1A', '#6B6B6B', '#C8442A'];

function colorForName(name) {
  if (!name) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
}

export default function Avatar({ name = '', photoUrl, size = 40 }) {
  const [imgFailed, setImgFailed] = useState(false);
  const initial = (name || '?').trim().charAt(0).toUpperCase() || '?';
  const showImage = photoUrl && !imgFailed;
  const bg = colorForName(name);

  if (showImage) {
    return (
      <img
        src={photoUrl}
        alt=""
        onError={() => setImgFailed(true)}
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          objectFit: 'cover',
          flexShrink: 0,
          background: '#EDEAE3',
        }}
      />
    );
  }

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: bg,
        color: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: Math.round(size * 0.4),
        fontWeight: 700,
        flexShrink: 0,
        fontFamily: 'inherit',
      }}
      aria-hidden
    >
      {initial}
    </div>
  );
}
